import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";

const LeaveStatement = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Leave Statement"));
  }, [dispatch]);

  const [searchTerm, setSearchTerm] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [filterFormData, setFilterData] = useState([]);
  const [apiStatus, setApiStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Column configuration with improved structure
  const columns = {
    TXNName: { text: "Transaction Name", visible: true, width: "150px" },
    TXNDate: {
      text: "Transaction Date",
      align: "center",
      visible: true,
      format: (date) => new Date(date).toLocaleDateString()
    },
    RecordedBy: { text: "Recorded By", visible: true, width: "120px" },
    Superior: { text: "Immediate Superior", visible: true, width: "150px" },
    FromDate: {
      text: "From Date",
      align: "center",
      visible: true,
      format: (date) => new Date(date).toLocaleDateString()
    },
    ToDate: {
      text: "To Date",
      align: "center",
      visible: true,
      format: (date) => new Date(date).toLocaleDateString()
    },
    Purpose: { text: "Purpose", visible: true, width: "200px" },
    Status: {
      text: "Status",
      visible: true,
      cellStyle: (status) => ({
        color: status === 'Approved' ? 'green' :
          status === 'Rejected' ? 'red' : 'inherit'
      })
    },
  };

  // Form configuration with better typing
  const formDatas = [
    {
      name: "Employee",
      type: "Select",
      options: employeeList,
      isRequired: true
    },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];

  // Fetch employee list on mount
  useEffect(() => {
    const fetchEmployeeList = async () => {
      try {
        setIsLoading(true);
        const response = await GetServiceCaller(`${API_URL}filter-leave-statement`);

        if (response?.status === 200) {
          const formattedEmployees = response.data.employeelist.map(emp => ({
            value: emp.value,
            label: emp.text,
          }));
          setEmployeeList(formattedEmployees);
        }
      } catch (error) {
        console.error("Error fetching employee list:", error);
        toast.error("Failed to load employee list");
      } finally {
        setIsLoading(false);
      }
    };

    fetchEmployeeList();
  }, []);

  // Fetch leave statements with error handling
  const fetchLeaveStatements = async (params = {}) => {
    setIsLoading(true);
    
    setApiStatus(undefined);
    try {
      const { employeeId, fromDate, toDate } = params;
      
      if (!employeeId) {
        toast.error("Please select an employee");
        setApiStatus('')
        return;
      }

      const response = await GetServiceCaller(
        `${API_URL}leave-statement/1?P_EmployeeID=${employeeId || ""}` +
        `&p_fromdate=${moment(fromDate).format("YYYY-MM-DD") || ""}&p_todate=${moment(toDate).format("YYYY-MM-DD") || ""}`
      );

      setApiStatus(response?.status);

      if (response?.data?.leaveStatement) {
        setEmployeeData(response.data.leaveStatement);
      } else {
        setEmployeeData([]);
        toast.info("No leave records found for the selected criteria");
      }
    } catch (error) {
      console.error("Error fetching leave statements:", error);
      toast.error("Failed to fetch leave statements");
      setEmployeeData([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle form changes with type safety
  const handleChange = (value, fieldName) => {
    setFilterData(prev => {
      const existingIndex = prev.findIndex(item => item.label === fieldName);

      if (existingIndex !== -1) {
        return prev.map((item, index) =>
          index === existingIndex
            ? { ...item, value: value?.value ?? value }
            : item
        );
      }

      return [...prev, {
        label: fieldName,
        value: value?.value ?? value
      }];
    });
  };

  // Handle form submission
  const handleGetData = () => {
    const employeeId = filterFormData.find(f => f.label === "Employee")?.value;
    const fromDate = filterFormData.find(f => f.label === "From Date")?.value;
    const toDate = filterFormData.find(f => f.label === "To Date")?.value;

    fetchLeaveStatements({ employeeId, fromDate, toDate });
  };

  // Reset form and fetch default data
  const handleReset = () => {
    setFilterData([]);
    fetchLeaveStatements({});
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">


        <div className="row">
          <Dynamic_PR_table
            data={employeeData}
            columns={columns}
            itemsPerPage={8}
            isSorting={true}
            handleReset={handleReset}
            isRequiredStatus={true}
            isApiStatus={apiStatus}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            isFilterRequired={true}
            formDatas={formDatas}
            filterFormData={filterFormData}
            handleChange={handleChange}
            handleGetData={handleGetData}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default LeaveStatement;